
import _uniqueBy from "lodash.uniqby"
import Vue from "vue"
import { sortCollator } from "@/utils"
import TableFilterSelect
  from "@/components/TableFilterSelect.vue"

const _uniqueById = (array) => _uniqueBy(array, "id")

export default Vue.extend({
  name: "EventsContestantsFilterMembers",

  components: {
    TableFilterSelect
  },

  props: {
    value: { type: Array, required: true },
    contestants: { type: Array, required: true },
    loading: { type: Boolean, required: false }
  },

  data() {
    return {
      selection: []
    }
  },

  computed: {
    members(): any {
      return _uniqueById(this.contestants.map((c) => c.clubMember))
        .sort((a, b) => {
          return sortCollator.compare(a.firstName, b.lastName)
        })
    }
  },

  watch: {
    selection(v): void {
      this.$emit("input", v)
    }
  },

  created() {
    this.selection = this.value
  },

  methods: {
    fullName({ firstName, lastName }): string {
      return `${firstName} ${lastName}`
    }
  }
})
